var map = {
	"./beurre.png": 232,
	"./ble.png": 94,
	"./cacao.png": 378,
	"./cafe.png": 362,
	"./down.png": 505,
	"./miel.png": 352,
	"./oeuf.png": 608,
	"./sucre.png": 313,
	"./up.png": 522,
	"./vanille.png": 532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 994;